// InventoryCloseTabs.js
import React from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';

// Your existing pages
import InventoryMonthClose from './components/biReports/InventoryMonthClose';
import InventoryCloseDecision from './components/biReports/InventoryCloseDecision';
import InventoryControlCenter from './components/biReports/InventoryControlCenter';
import InventoryAdjustmentsAnalysis from './components/biReports/InventoryAdjustmentsAnalysis';
import RapDecisions from './components/biReports/InventoryRapDecisions';
import InventoryInternalTransactions from './components/biReports/InventoryInternalTransactions';
import InventoryUI from './components/biReports/InventoryUI';

function TabPanel(props) {
  const { children, value, index, sx, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`invclose-tabpanel-${index}`}
      aria-labelledby={`invclose-tab-${index}`}
      sx={{
        display: value === index ? 'flex' : 'none',
        flexDirection: 'column',
        width: '100%',
        minWidth: 0,
        minHeight: 0,
        ...sx,
      }}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            pt: { xs: 0.25, sm: 0.35, md: 0.5 },
            width: '100%',
            height: '100%',
            maxHeight: '100%',
            minWidth: 0,
            minHeight: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

function a11yProps(index) {
  return {
    id: `invclose-tab-${index}`,
    'aria-controls': `invclose-tabpanel-${index}`,
  };
}

class InventoryCloseTabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 0,
      // If you decide to share filters later, lift them here and pass as props
      // filters: { period: dayjs().format('YYYY-MM'), location: '', product: '' }
    };
  }

  componentDidMount() {
    if (this.props.onReady) {
      this.props.onReady();
    }
  }

  handleTabChange = (_e, newValue) => {
    this.setState({ tab: newValue });
  };

  render() {
    const { tab } = this.state;

    const fixedTabSx = {
      p: {
        xs: 0.5,
        sm: 1,
      },
      height: {
        xs: 'calc(100dvh - 128px)',
        sm: 'calc(100dvh - 140px)',
        md: 700,
        lg: 740,
      },
      maxHeight: {
        xs: 'calc(100dvh - 128px)',
        sm: 'calc(100dvh - 140px)',
        md: 700,
        lg: 740,
      },
      minHeight: 0,
      overflow: 'hidden',
    };

    const fixedChildSx = {
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      minWidth: 0,
      minHeight: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    };

    return (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          maxWidth: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          ml: {
            xs: 'calc(50% - 50vw + 4px)',
            sm: 0,
          },
          bgcolor: '#f3f6fa',
          overflow: 'hidden',
          pt: { xs: 0.25, sm: 0.5, md: 0.75 },
          pb: { xs: 0.25, sm: 0.5, md: 0.75 },
          px: { xs: 0.5, sm: 0.85, md: 1 },
          boxSizing: 'border-box',

          '& .MuiCard-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
            borderRadius: { xs: '14px', sm: '16px' },
          },

          '& .MuiPaper-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
          },

          '& table': {
            maxWidth: '100%',
          },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            width: '100%',
            minWidth: 0,
            overflow: 'hidden',
            mb: { xs: 0.25, sm: 0.35, md: 0.5 },
            borderRadius: { xs: '12px', sm: '14px' },
            border: '1px solid rgba(15, 23, 42, 0.08)',
            boxShadow: '0 3px 10px rgba(15, 23, 42, 0.07)',
            bgcolor: 'rgba(248,250,252,0.98)',
          }}
        >
          <Tabs
            value={tab}
            onChange={this.handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="Inventory Close Tabs"
            sx={{
              minHeight: { xs: 34, sm: 38 },
              px: { xs: 0.25, sm: 0.75 },
              '& .MuiTabs-scroller': {
                overflowX: 'auto !important',
              },
              '& .MuiTabs-indicator': {
                height: 2,
                borderRadius: 2,
              },
              '& .MuiTab-root': {
                minHeight: { xs: 34, sm: 38 },
                textTransform: 'none',
                fontWeight: 700,
                fontSize: { xs: 11.5, sm: 13 },
                px: { xs: 0.8, sm: 1.35 },
                whiteSpace: 'nowrap',
              },
            }}
          >
            <Tab label="Month Close" {...a11yProps(0)} />
            <Tab label="Inventory" {...a11yProps(1)} />
            <Tab label="Inv Adj." {...a11yProps(2)} />
            <Tab label="Inv Dec." {...a11yProps(3)} />
            <Tab label="Inv Trans." {...a11yProps(4)} />
            <Tab label="Inv Check" {...a11yProps(5)} />
            <Tab label="Control Center" {...a11yProps(6)} />
          </Tabs>
        </Paper>

        <Box
          sx={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflow: 'hidden',
            flex: 1,
            minHeight: 0,

            '& > div': {
              width: '100%',
              maxWidth: '100%',
              minWidth: 0,
            },

            '& .MuiCard-root': {
              boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
              border: '1px solid rgba(15, 23, 42, 0.06)',
            },
          }}
        >
          <TabPanel value={tab} index={0} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <InventoryMonthClose />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={1} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <InventoryCloseDecision />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={2} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <InventoryAdjustmentsAnalysis />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={3} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <RapDecisions />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={4} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <InventoryInternalTransactions />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={5} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <InventoryUI />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={6} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <InventoryControlCenter />
            </Box>
          </TabPanel>
        </Box>
      </Box>
    );
  }
}

export default InventoryCloseTabs;